import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { RepairTypeEnum } from '../enums/repair-type.enum';
import { RepairInterface } from '../interfaces/repair.interface';

@Exclude()
export class RepairDto extends CommonEntityDto implements RepairInterface {
  @ApiProperty({
    title: 'Description',
    nullable: true,
  })
  @Expose()
  description!: string;

  @ApiProperty({
    title: 'Repair Type',
    nullable: true,
  })
  @Expose()
  repairType!: RepairTypeEnum;
}
